"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../../utils");
var _constant = require("../../../../constant");
var _styled = require("../../../base/styled");
var _collapsible = _interopRequireDefault(require("../../../collapsible"));
var _styled2 = require("../styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var WhatTheBuzz = function WhatTheBuzz(_ref) {
  var company = _ref.company,
    open = _ref.open,
    onCollapse = _ref.onCollapse,
    isValid = _ref.isValid,
    showValidateIcon = _ref.showValidateIcon,
    showDivider = _ref.showDivider;
  return /*#__PURE__*/_react.default.createElement(_collapsible.default, {
    id: _constant.companySection.WHATS_THE_BUZZ,
    onCollapse: onCollapse,
    title: "What's the Buzz",
    open: open.whatsTheBuzz,
    isValid: isValid,
    showValidateIcon: showValidateIcon,
    showDivider: showDivider
  }, company.recentPress[0] && /*#__PURE__*/_react.default.createElement(_styled2.BlockText, null, /*#__PURE__*/_react.default.createElement(_styled2.Title, null, "Recent Press"), company.recentPress.map(function (recentPress) {
    return /*#__PURE__*/_react.default.createElement(_styled.Column, {
      key: recentPress.id,
      $bsStyle: {
        marginBottom: '24px'
      }
    }, /*#__PURE__*/_react.default.createElement(_styled2.Anchor, {
      href: recentPress.url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, (0, _utils.getUrlWithoutProtocol)(recentPress.url)), /*#__PURE__*/_react.default.createElement(_styled.PreformattedText, {
      $bsStyle: {
        marginBottom: '0px'
      }
    }, recentPress.title));
  })));
};
WhatTheBuzz.propTypes = {
  company: _utils.companyProps.isRequired,
  open: _utils.opportunitySectionsProps.isRequired,
  onCollapse: _propTypes.default.func.isRequired,
  isValid: _propTypes.default.bool.isRequired,
  showValidateIcon: _propTypes.default.bool,
  showDivider: _propTypes.default.bool
};
WhatTheBuzz.defaultProps = {
  showValidateIcon: false,
  showDivider: true
};
var _default = WhatTheBuzz;
exports.default = _default;